/**
 * The capture-capability report deduplicated (#438).
 *
 * `PATCH /v1/devices/me` re-reports the audio-stack probe at every recording
 * start so the server knows what this device's mic chain actually honours --
 * but the probe's answer almost never moves on one device, and an unchanged
 * PATCH is a write nobody reads. The call site therefore asks
 * `capabilitiesChanged` first and confirms with `markCapabilitiesReported`
 * only once the server answered, so a failed PATCH is simply retried at the
 * next start. The diagnostics screen's mic-ceiling probe always sends: it
 * exists to produce a changed answer.
 */

let lastReportedJson: string | null = null;
let lastDevice: string | undefined;

/** Whether these capabilities differ from the last ones the server acknowledged. */
export function capabilitiesChanged(caps: unknown, device?: string): boolean {
  return device !== lastDevice || JSON.stringify(caps ?? null) !== lastReportedJson;
}

/** Called only after the PATCH succeeded. */
export function markCapabilitiesReported(caps: unknown, device?: string): void {
  lastDevice = device;
  lastReportedJson = JSON.stringify(caps ?? null);
}
